export interface IOrdersHistoryDiner {
  name: string;
  email: string;
  expense_code?: string;
}
export interface IOrdersHistory {
  order_id: string;
  delivery_on: string;
  ordered_by: IOrdersHistoryDiner;
  total_charge: number;
  order_type: string;
  department: string;
  location: string;
  restaurant_name: string;
  order_number: string;
  delivery_on_utc: string;
  time_zone?: ITimeZone;
  total_expense: number;
  allocation_participants: IOrdersHistoryDiner[];
  group_order: boolean;
  group_order_info?: IGroupOrderInfo;
}

export interface ITimeZone {
  id: string;
  name: string;
  raw_offset: number;
}

export interface IDeliveryInfo {
  address_country: string;
  address_locality: string;
  address_region: string;
  cross_streets: string;
  delivery_instructions: string;
  email: string;
  green_indicated: boolean;
  latitude: string;
  longitude: string;
  name: string;
  phone: string;
  postal_code: string;
  street_address1: string;
  street_address2: string;
  time_zone: ITimeZone;
}

export interface IAllocationDetails {
  name: string;
  amount: number;
  expense_code: string;
}

export interface IOrdersReceipt {
  order_id: string;
  order_number: string;
  delivered_on: string;
  total_expense: number;
  loc_total: number;
  transaction_fee: number;
  item_subtotal: number;
  sales_tax: number;
  tip: number;
  total_charge: number;
  meal_type: MealType;
  time_placed: string;
  time_placed_utc: string;
  delivered_on_utc: string;
  expense_comments: string;
  ordered_by: IOrdersHistoryDiner;
  allocation_details: IAllocationDetails[];
  delivery_info: IDeliveryInfo;
  order_charges: IOrderCharges;
  order_payments: IOrderPayments;
  savings_breakdown: SavingsBreakdown;
  ordered_from: IOrderedFrom;
  line_items: ILineItem[] | null;
  time_zone: ITimeZone;
  group_order: boolean;
  group_admin: boolean;
  group_order_info: IReceiptGroupOrderInfo;
}

export interface IGroupOrderInfo {
  name: string;
  order_number: number;
  order_uuid: number;
}

export interface IReceiptGroupOrderInfo {
  participant_lines: IParticipantLine[];
}

export interface IParticipantLine {
  diner_info: IDinerInfo;
  order_lines: IOrderLines;
}

export interface IDinerInfo {
  email: string;
  id: string;
  name: string;
  phone?: string;
}

export interface IOrderLines {
  diner_total: number;
  line_items: ILineItem[];
  non_taxable: number;
  taxable: number;
  total: number;
}

export enum OrderPaymentType {
  PROMO_CODE = 'PROMO_CODE',
  REWARD = 'REWARD',
  UNIFIED_REWARD = 'UNIFIED_REWARD',
  CORPORATE_LINE_OF_CREDIT = 'CORPORATE_LINE_OF_CREDIT',
  CREDIT_CARD = 'CREDIT_CARD',
}

export enum OrderSpecialFeeType {
  DELIVERY = 'DELIVERY',
  SERVICE = 'SERVICE',
  CHAIN_SERVICE_FEE = 'CHAIN_SERVICE_FEE',
  SERVICE_TOLL = 'SERVICE_TOLL',
}
export interface IOrderPayment {
  id: string;
  type: OrderPaymentType;
  amount: number;
  payment_id?: string;
  metadata: Record<string, string>;
}

export interface IOrderCharges {
  exempted_taxes: IExemptedTaxes;
  total_expense: number;
  loc_total: number;
  transaction_fee: number;
  item_subtotal: number;
  tip: number;
  total_charge: number;
  order_fees: IOrderFees;
}

export interface FeeDetail {
  display_text: string;
}

export enum FeeType {
  DELIVERY = 'DELIVERY',
  SERVICE = 'SERVICE',
}

export enum FeeItemProperty {
  CALCULATED_AMOUNT = 'calculated_amount',
  NON_ADJUSTED_AMOUNT = 'non_adjusted_amount',
}

export interface FeeSavings {
  [FeeType.DELIVERY]?: FeeDetail;
  [FeeType.SERVICE]?: FeeDetail;
}
export interface SavingsBreakdown {
  fee_savings: FeeSavings;
}

export interface IOrderPayments {
  payments: IOrderPayment[];
  total: number;
}

export interface IExemptedTaxes {
  total: number;
  delivery: number;
  sales: number;
}

export interface IOrderFees {
  delivery: number;
  total: number;
  service: number;
  fee_items: IOrderChargesFeeItems[];
}

export interface IOrderChargesFeeItems {
  adjustment_reason?: string | null;
  initial_amount: number;
  calculated_amount: number;
  non_adjusted_amount?: number;
  group: string;
  id: string;
  name: string;
  type: string;
}

export interface ILineItem {
  name: string;
  price: number;
  quantity: number;
}

export interface IOrderedFrom {
  restaurant_name: string;
  phone_number: string;
  address: string;
}
export enum MealType {
  STANDARD = 'STANDARD',
  CATERING = 'CATERING',
  GROUP = 'GROUP',
}

export interface IParticipantLineMap {
  dinerName: string;
  isHost: boolean;
  items: IItem[];
  dinerId?: string;
}

export interface IItem {
  quantity: number;
  name: string;
  price: string;
}
